import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroTranscricaoSustentacaoOralEletronica extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Existência de transcrição de sustentação oral eletrônica de advogado';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return !!(
            registro.pedidoSustentacaoOral?.pedidosDetalhados && this.#temTranscricaoSustentacaoOralEletronica(registro)
        );
    }

    #temTranscricaoSustentacaoOralEletronica(registro) {
        return registro.pedidoSustentacaoOral.pedidosDetalhados.some((pedido) => {
            return pedido.advogados?.some((advogado) => {
                return advogado.documentosSustentacao?.some((arquivo) => {
                    return !!(arquivo.transcricaoDisponivel === true || arquivo.transcricaoDisponivel === 'true');
                });
            });
        });
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
